export default __webpack_public_path__ + "static/media/socket.f093bb29.svg";